<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端（原样不动） ====================== -->
    <div class="pc-version">
      <div
        class="menu-table-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-loading-spinner="el-icon-loading"
        element-background-color="rgba(0, 0, 0, 0.3)"
      >
        <el-card v-if="!showFightBoxCard">
          <div class="search-bar">
            <el-input
              v-model="searchParams.name"
              placeholder="请输入名称"
              clearable
              style="width: 220px; margin-right: 10px"
            ></el-input>

            <el-button type="primary" icon="el-icon-search" @click="getList"
              >搜索</el-button
            >
            <el-button icon="el-icon-refresh" @click="resetSearch"
              >重置</el-button
            >
            <el-button type="success" icon="el-icon-plus" @click="handleAdd"
              >添加闯关</el-button
            >

            <el-popover
              placement="bottom"
              title="显示列筛选"
              trigger="click"
              width="220"
            >
              <el-checkbox-group v-model="checkedColumns">
                <el-checkbox
                  v-for="item in columnOptions"
                  :key="item.prop"
                  :label="item.prop"
                  >{{ item.label }}</el-checkbox
                >
              </el-checkbox-group>
              <div style="text-align: right; margin-top: 8px">
                <el-button size="mini" @click="handleCheckAll">全选</el-button>
                <el-button size="mini" @click="handleClearAll">清空</el-button>
              </div>
              <el-button slot="reference" icon="el-icon-s-tools" type="info"
                >列筛选</el-button
              >
            </el-popover>
          </div>

          <el-table
          height="900"
            :data="tableData"
            border
            stripe
            style="width: 100%; margin-top: 20px"
            @row-click="handleRowClick"
          >
            <el-table-column
              label="ID"
              prop="id"
              width="80"
              align="center"
              v-if="checkedColumns.includes('id')"
            />
            <el-table-column
              label="名称"
              prop="name"
              min-width="180"
              v-if="checkedColumns.includes('name')"
            />
            <el-table-column
              label="图片"
              width="120"
              align="center"
              v-if="checkedColumns.includes('image')"
            >
              <template slot-scope="scope">
                <img
                  :src="scope.row.image"
                  style="width: 60px; height: 60px; object-fit: cover"
                />
              </template>
            </el-table-column>
            <el-table-column
              label="价格"
              prop="price"
              width="100"
              align="center"
              v-if="checkedColumns.includes('price')"
            />
            <el-table-column
              label="销量"
              prop="sales"
              width="100"
              align="center"
              v-if="checkedColumns.includes('sales')"
            />
            <el-table-column
              label="关口数"
              prop="fight_num"
              width="120"
              align="center"
              v-if="checkedColumns.includes('fight_num')"
            />
            <el-table-column
              label="收入"
              prop="income"
              width="100"
              align="center"
              v-if="checkedColumns.includes('income')"
            />
            <el-table-column
              label="支出"
              prop="pay"
              width="100"
              align="center"
              v-if="checkedColumns.includes('pay')"
            />
            <!-- 利润列 -->
            <el-table-column
              label="利润"
              width="120"
              align="center"
              v-if="checkedColumns.includes('profit')"
            >
              <template slot-scope="scope">
                <span v-if="Number(scope.row.income) === 0">--</span>
                <span
                  v-else
                  :style="{
                    color:
                      scope.row.income - scope.row.pay >= 0
                        ? '#00c48c'
                        : '#f56c6c',
                  }"
                >
                  {{
                    (
                      ((scope.row.income - scope.row.pay) / scope.row.income) *
                      100
                    ).toFixed(2)
                  }}%
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="排序"
              prop="sort"
              width="80"
              align="center"
              v-if="checkedColumns.includes('sort')"
            />

            <el-table-column
              label="状态"
              width="180"
              align="center"
              v-if="checkedColumns.includes('status')"
            >
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.status"
                  active-text="上架"
                  inactive-text="下架"
                  :active-value="1"
                  :inactive-value="0"
                  @click.native.stop
                  @change="handleStatusChange(scope.row)"
                />
              </template>
            </el-table-column>

            <el-table-column
              label="创建时间"
              prop="created_at"
              width="180"
              v-if="checkedColumns.includes('created_at')"
            />
            <el-table-column
              label="更新时间"
              prop="updated_at"
              width="180"
              v-if="checkedColumns.includes('updated_at')"
            />

            <el-table-column
              label="操作"
              width="260"
              align="center"
              fixed="right"
              v-if="checkedColumns.includes('action')"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  icon="el-icon-edit"
                  @click.stop="handleEdit(scope.row)"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  icon="el-icon-s-data"
                  @click.stop="openFightBoxNum(scope.row)"
                  >关口</el-button
                >
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageTotal"
            style="margin-top: 20px; text-align: right"
          />
        </el-card>

        <el-card v-else>
          <div class="search-bar">
            <el-button
              icon="el-icon-back"
              type="primary"
              @click="closeFightBoxCard"
              >返回闯关列表</el-button
            >
            <el-button
              type="success"
              icon="el-icon-plus"
              @click="handleFightBoxAdd"
              >添加关卡</el-button
            >
          </div>

          <el-table
            :data="numList"
            v-loading="numLoading"
            border
            stripe
            style="width: 100%; margin-top: 20px"
            size="mini"
            @row-click="showBoxNumDetail"
          >
            <el-table-column prop="id" label="ID" width="80" align="center" />
            <el-table-column prop="box" label="关口" align="center" />
            <el-table-column prop="price" label="价格" align="center" />
            <el-table-column
              label="亏损预估值"
              prop="loss_price"
              width="120"
              align="center"
            />
            <el-table-column prop="type_desc" label="类型" align="center" />
            <el-table-column prop="cycle_num" label="周期数量" align="center" />
            <el-table-column label="奖品图片" width="120" align="center">
              <template slot-scope="scope">
                <img
                  :src="scope.row.goods_image"
                  style="width: 60px; height: 60px; object-fit: cover"
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="goods_name"
              label="奖品名称"
              align="center"
            />
            <el-table-column
              prop="created_at"
              label="创建时间"
              align="center"
            />
            <el-table-column label="操作" align="center" :key="1" width="300">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  icon="el-icon-edit"
                  @click.stop="handleFightBoxEdit(scope.row)"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  icon="el-icon-box"
                  style="color: #e6a23c"
                  @click.stop="openPrizeList(scope.row)"
                  >赏品</el-button
                >
                <el-button
                  type="text"
                  icon="el-icon-tickets"
                  style="color: #409eff"
                  @click.stop="openBoxNumDrawRecord(scope.row)"
                  >抽奖记录</el-button
                >
                <el-button
                  type="text"
                  icon="el-icon-delete"
                  style="color: #f56c6c"
                  @click.stop="delFightBoxNum(scope.row.id)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleNumSizeChange"
            @current-change="handleNumCurrentChange"
            :current-page="numSearch.page"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="numTotal"
            style="margin-top: 20px; text-align: right"
          />
        </el-card>

        <!-- 👇 PC 弹窗：只在 PC 显示 -->
        <div v-if="!$isMobile">
          <!-- 主闯关弹窗 -->
          <el-dialog
            :title="dialogType == 'add' ? '添加闯关' : '编辑闯关'"
            :visible.sync="dialogVisible"
            width="750px"
            @close="resetForm"
            append-to-body
          >
            <el-form
              :model="form"
              :rules="addRules"
              ref="formRef"
              label-width="120px"
            >
              <el-form-item label="闯关名称" prop="name">
                <el-input
                  v-model="form.name"
                  placeholder="请输入闯关名称"
                  style="width: 320px"
                />
              </el-form-item>
              <el-form-item label="闯关图片" prop="image">
                <div style="display: flex; align-items: center; gap: 12px">
                  <el-button
                    type="primary"
                    icon="el-icon-picture"
                    @click="openImageDialog"
                    >选择图片</el-button
                  >
                  <div
                    v-if="form.image"
                    style="
                      border: 1px solid #eee;
                      padding: 4px;
                      border-radius: 4px;
                    "
                  >
                    <img
                      :src="form.image"
                      style="
                        width: 52px;
                        height: 52px;
                        object-fit: cover;
                        display: block;
                      "
                    />
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="价格" prop="price">
                <el-input
                  v-model="form.price"
                  placeholder="请输入价格"
                  style="width: 320px"
                />
              </el-form-item>
              <el-form-item label="关口数" prop="fight_num">
                <el-input
                  v-model="form.fight_num"
                  placeholder="请输入关口数"
                  style="width: 320px"
                />
              </el-form-item>
              <el-form-item label="排序" prop="sort">
                <el-input
                  v-model="form.sort"
                  placeholder="请输入排序值"
                  style="width: 320px"
                />
              </el-form-item>
            </el-form>
            <div slot="footer">
              <el-button @click="dialogVisible = false">取消</el-button>
              <el-button type="primary" @click="submitForm">确认提交</el-button>
            </div>
          </el-dialog>

          <!-- 添加/编辑关卡弹窗 -->
          <el-dialog
            :title="fightBoxNumId ? '编辑关卡' : '添加关卡'"
            :visible.sync="fightBoxNumDialog"
            width="700px"
            @close="resetFightBoxNumForm"
            append-to-body
          >
            <el-form
              :model="fightBoxNumForm"
              ref="fightBoxNumRef"
              label-width="120px"
            >
              <el-form-item label="关口">
                <el-input
                  v-model="fightBoxNumForm.box"
                  placeholder="请输入关口"
                  style="width: 300px"
                />
              </el-form-item>

              <el-form-item label="周期数量">
                <el-input
                  v-model="fightBoxNumForm.cycle_num"
                  placeholder="请输入周期数量"
                  style="width: 300px"
                />
              </el-form-item>

              <el-form-item label="类型">
                <el-select
                  v-model.number="fightBoxNumForm.type"
                  placeholder="请选择类型"
                  style="width: 300px"
                >
                  <el-option
                    v-for="t in typeList"
                    :key="t.type"
                    :label="t.desc"
                    :value="t.type"
                  />
                </el-select>
              </el-form-item>

              <el-form-item label="选择商品" v-if="fightBoxNumForm.type == 2">
                <el-button type="primary" size="mini" @click="openGoodsDialog"
                  >选择门票商品</el-button
                >
                <div style="margin-top: 8px">
                  已选商品ID：{{ fightBoxNumForm.goods_id || "未选择" }}
                  <span
                    v-if="selectedGoodsName"
                    style="color: #67c23a; margin-left: 10px"
                    >{{ selectedGoodsName }}</span
                  >
                </div>
              </el-form-item>

              <el-form-item label="单价" v-if="fightBoxNumForm.type == 1">
                <el-input
                  v-model="fightBoxNumForm.price"
                  placeholder="请输入单价"
                  style="width: 300px"
                />
              </el-form-item>
              <el-form-item label="亏损预估值">
                <el-input
                  v-model="fightBoxNumForm.loss_price"
                  placeholder="请输入亏损预估值"
                  style="width: 300px"
                />
              </el-form-item>
              <div
                v-if="
                  levelList.length > 0 &&
                  fightBoxNumForm.probability_info.length > 0
                "
                style="margin-top: 15px"
              >
                <div style="font-weight: bold; margin-bottom: 10px">
                  概率配置
                </div>
                <div
                  v-for="(lvl, index) in levelList"
                  :key="lvl.level_id"
                  style="
                    display: flex;
                    gap: 10px;
                    margin-bottom: 8px;
                    align-items: center;
                  "
                >
                  <span style="width: 120px">{{ lvl.name }}</span>
                  <el-input
                    v-model="
                      fightBoxNumForm.probability_info[index].probability
                    "
                    placeholder="概率"
                    style="width: 120px"
                  />
                </div>
              </div>
            </el-form>

            <div slot="footer">
              <el-button @click="fightBoxNumDialog = false">取消</el-button>
              <el-button type="primary" @click="submitAdd">确认提交</el-button>
            </div>
          </el-dialog>
          <!-- 关卡抽奖记录弹窗 -->
          <el-dialog
            :title="`${currentBoxDrawInfo.box}关口 - 抽奖记录`"
            :visible.sync="boxNumDrawRecordDialog"
            width="1300px"
            append-to-body
          >
            <div v-loading="boxNumDrawLoading">
              <el-table
                :data="boxNumDrawList"
                border
                stripe
                size="mini"
                style="width: 100%; margin-top: 10px"
              >
                <el-table-column
                  label="记录ID"
                  prop="id"
                  width="80"
                  align="center"
                />
                <el-table-column label="用户头像" width="90" align="center">
                  <template slot-scope="scope">
                    <img
                      :src="scope.row.avatar"
                      style="
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;
                        object-fit: cover;
                      "
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  label="用户昵称"
                  prop="nickname"
                  width="120"
                  align="center"
                />
                <el-table-column
                  label="订单ID"
                  prop="box_order_id"
                  width="110"
                  align="center"
                />
                <el-table-column label="奖品图" width="90" align="center">
                  <template slot-scope="scope">
                    <img
                      :src="scope.row.box_prize_image"
                      style="
                        width: 50px;
                        height: 50px;
                        object-fit: cover;
                        border-radius: 4px;
                      "
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  label="奖品名称"
                  prop="box_prize_name"
                  min-width="160"
                  align="center"
                />
                <el-table-column
                  label="等级"
                  prop="level_name"
                  width="80"
                  align="center"
                />
                <el-table-column
                  label="单价"
                  prop="price"
                  width="90"
                  align="center"
                />
                <el-table-column
                  label="回收价"
                  prop="recovery_price"
                  width="90"
                  align="center"
                />
                <el-table-column
                  label="中奖数量"
                  prop="num"
                  width="90"
                  align="center"
                />
                <el-table-column
                  label="倍数"
                  prop="multiple"
                  width="70"
                  align="center"
                />
                <el-table-column
                  label="流水号"
                  prop="times"
                  width="100"
                  align="center"
                />
                <el-table-column
                  label="创建时间"
                  prop="created_at"
                  width="180"
                  align="center"
                />
              </el-table>
              <el-pagination
                @size-change="handleBoxNumDrawSizeChange"
                @current-change="handleBoxNumDrawCurrentChange"
                :current-page="boxNumDrawParams.page"
                :page-sizes="[15, 30, 50]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="boxNumDrawTotal"
                style="margin-top: 15px; text-align: right"
              />
            </div>
            <div slot="footer">
              <el-button @click="boxNumDrawRecordDialog = false"
                >关闭</el-button
              >
            </div>
          </el-dialog>
          <!-- 商品选择 -->
          <el-dialog
            title="选择门票商品"
            :visible.sync="goodsDialogVisible"
            width="900px"
            append-to-body
          >
            <div v-loading="goodsLoading" style="padding: 10px">
              <div class="goods-list">
                <div
                  class="goods-item"
                  v-for="item in goodsList"
                  :key="item.id"
                  @click="selectGoodsItem(item)"
                  :class="selectedGoodsId == item.id ? 'goods-selected' : ''"
                >
                  <img
                    :src="item.image"
                    style="width: 100px; height: 100px; object-fit: cover"
                  />
                  <div style="font-size: 12px; margin-top: 5px">
                    {{ item.title }}
                  </div>
                  <div style="color: red; font-size: 12px">
                    {{ item.price }}元
                  </div>
                </div>
              </div>
              <el-pagination
                @size-change="handleGoodsSizeChange"
                @current-change="handleGoodsCurrentChange"
                :current-page="goodsParams.page"
                :page-sizes="[10, 20, 30]"
                :total="goodsTotal"
                layout="total, sizes, prev, pager, next, jumper"
                style="text-align: center; margin-top: 20px"
              />
            </div>
            <div slot="footer">
              <el-button @click="goodsDialogVisible = false">取消</el-button>
              <el-button type="primary" @click="confirmSelectGoods"
                >确认选择</el-button
              >
            </div>
          </el-dialog>

          <!-- PC 图片选择 -->
          <el-dialog
            title="选择图片"
            :visible.sync="imageDialogVisible"
            width="850px"
            append-to-body
          >
            <div
              v-loading="imageLoading"
              element-loading-text="图片加载中..."
              style="padding: 10px"
            >
              <div
                style="
                  display: flex;
                  gap: 10px;
                  margin-bottom: 15px;
                  align-items: center;
                "
              >
                <el-select
                  v-model.number="imageSearch.type"
                  placeholder="图片类型"
                  style="width: 180px"
                  clearable
                >
                  <el-option
                    v-for="item in image_type"
                    :key="item.type"
                    :label="item.desc"
                    :value="item.type"
                  />
                </el-select>
                <el-button
                  type="primary"
                  icon="el-icon-search"
                  @click="getImageList"
                  >筛选</el-button
                >
                <el-button icon="el-icon-refresh" @click="resetImageSearch"
                  >重置</el-button
                >
              </div>
              <div
                style="
                  display: flex;
                  flex-wrap: wrap;
                  gap: 12px;
                  max-height: 420px;
                  overflow-y: auto;
                  padding: 5px;
                "
              >
                <div
                  v-for="img in imageList"
                  :key="img.id"
                  @click="selectImage(img)"
                  style="
                    cursor: pointer;
                    padding: 4px;
                    border-radius: 6px;
                    text-align: center;
                  "
                  :style="{
                    border:
                      selectedImageUrl == img.url
                        ? '2px solid #1989fa'
                        : '2px solid transparent',
                    background:
                      selectedImageUrl == img.url ? '#f0f7ff' : 'transparent',
                  }"
                >
                  <img
                    :src="img.url"
                    style="
                      width: 100px;
                      height: 100px;
                      object-fit: cover;
                      border-radius: 4px;
                      display: block;
                    "
                  />
                  <span
                    style="
                      font-size: 12px;
                      margin-top: 4px;
                      color: #666;
                      display: block;
                    "
                    >{{ getImageTypeName(img.type) }}</span
                  >
                </div>
              </div>
              <el-pagination
                @size-change="handleImageSizeChange"
                @current-change="handleImageCurrentChange"
                :current-page="imageSearch.page"
                :page-size="imageSearch.page_size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="imageTotal"
                style="margin-top: 15px; text-align: right"
              />
            </div>
            <div slot="footer">
              <el-button @click="imageDialogVisible = false">取消</el-button>
              <el-button type="primary" @click="confirmSelectImage"
                >确认选择</el-button
              >
            </div>
          </el-dialog>

          <!-- 详情 -->
          <el-dialog
            :title="detailRow ? detailRow.name + ' 的详情' : '详情'"
            :visible.sync="detailDialogVisible"
            width="850px"
            append-to-body
          >
            <div v-loading="detailLoading" style="padding: 10px">
              <el-descriptions border :column="2" size="small" v-if="detailRow">
                <el-descriptions-item label="图片">
                  <img
                    :src="detailRow.image"
                    style="
                      width: 80px;
                      height: 80px;
                      object-fit: cover;
                      border-radius: 4px;
                    "
                  />
                </el-descriptions-item>
                <el-descriptions-item label="ID">{{
                  detailRow.id
                }}</el-descriptions-item>
                <el-descriptions-item label="名称">{{
                  detailRow.name
                }}</el-descriptions-item>
                <el-descriptions-item label="价格">{{
                  detailRow.price
                }}</el-descriptions-item>
                <el-descriptions-item label="关口数">{{
                  detailRow.fight_num
                }}</el-descriptions-item>
                <el-descriptions-item label="销量">{{
                  detailRow.sales
                }}</el-descriptions-item>
                <el-descriptions-item label="收入">{{
                  detailRow.income
                }}</el-descriptions-item>
                <el-descriptions-item label="支出">{{
                  detailRow.pay
                }}</el-descriptions-item>
                <el-descriptions-item label="利润">
                  <span v-if="Number(detailRow.income) === 0">--</span>
                  <span
                    v-else
                    :style="{
                      color:
                        detailRow.income - detailRow.pay >= 0
                          ? '#00C48C'
                          : '#F56C6C',
                    }"
                  >
                    {{
                      (
                        ((detailRow.income - detailRow.pay) /
                          detailRow.income) *
                        100
                      ).toFixed(2)
                    }}%
                  </span>
                </el-descriptions-item>
                <el-descriptions-item label="排序">{{
                  detailRow.sort
                }}</el-descriptions-item>
                <el-descriptions-item label="状态">
                  <span
                    :style="
                      detailRow.status == 1
                        ? { color: '#00C48C' }
                        : { color: '#F56C6C' }
                    "
                    >{{ detailRow.status == 1 ? "上架" : "下架" }}</span
                  >
                </el-descriptions-item>
                <el-descriptions-item label="创建时间">{{
                  detailRow.created_at
                }}</el-descriptions-item>
                <el-descriptions-item label="更新时间">{{
                  detailRow.updated_at
                }}</el-descriptions-item>
              </el-descriptions>
            </div>
          </el-dialog>

          <!-- 关卡详情弹窗 -->
          <el-dialog
            title="关卡详情"
            :visible.sync="boxNumDetailVisible"
            width="700px"
            append-to-body
          >
            <div v-if="boxNumDetail" style="font-size: 14px; line-height: 28px">
              <p><b>关口ID：</b> {{ boxNumDetail.id }}</p>
              <p><b>关口：</b> {{ boxNumDetail.box }}</p>
              <p><b>类型：</b> {{ boxNumDetail.type_desc }}</p>
              <p><b>单价：</b> {{ boxNumDetail.price }}</p>
              <p><b>亏损预估值：</b> {{ boxNumDetail.loss_price || 0 }}</p>
              <p><b>周期数量：</b> {{ boxNumDetail.cycle_num }}</p>
              <p><b>商品ID：</b> {{ boxNumDetail.goods_id || "无" }}</p>
              <p><b>商品名称：</b> {{ boxNumDetail.goods_name || "无" }}</p>
              <p><b>创建时间：</b> {{ boxNumDetail.created_at }}</p>

              <div style="margin-top: 20px">
                <div style="font-weight: bold; margin-bottom: 10px">
                  概率配置：
                </div>
                <el-table
                  :data="boxNumDetail.probability"
                  border
                  size="mini"
                  style="width: 100%"
                >
                  <el-table-column
                    label="等级ID"
                    prop="level_id"
                    align="center"
                  />
                  <el-table-column
                    label="概率"
                    prop="probability"
                    align="center"
                  />
                </el-table>
              </div>
            </div>
          </el-dialog>
          <!-- 赏品列表弹窗 -->
          <el-dialog
            title="赏品列表"
            :visible.sync="prizeDialogVisible"
            width="1200px"
            append-to-body
          >
            <div style="margin-bottom: 15px">
              <el-button
                type="success"
                icon="el-icon-plus"
                @click="openAddPrizeDialog"
                >添加赏品</el-button
              >
              <el-button
                type="primary"
                icon="el-icon-check"
                @click="submitAddPrize"
                >确认添加</el-button
              >
            </div>

            <!-- 未保存数据 -->
            <div style="margin-bottom: 20px">
              <p style="font-weight: bold; margin-bottom: 8px">未保存数据</p>
              <el-table
                :data="tempPrizeList"
                border
                size="mini"
                style="width: 100%"
              >
                <el-table-column
                  label="ID"
                  prop="id"
                  width="70"
                  align="center"
                />
                <el-table-column label="商品图片" align="center" width="100">
                  <template slot-scope="scope">
                    <img
                      :src="scope.row.image"
                      style="width: 50px; height: 50px; object-fit: cover"
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  label="商品名称"
                  prop="title"
                  min-width="180"
                />
                <el-table-column label="赏品类型" width="110" align="center">
                  <template slot-scope="scope">
                    <span
                      :style="{
                        color:
                          scope.row.goods_type == 1 ? '#008000' : '#1890ff',
                      }"
                    >
                      {{ scope.row.goods_type == 1 ? "真实赏品" : "虚拟赏品" }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="等级" width="120" align="center">
                  <template slot-scope="scope">
                    <el-select
                      v-model="scope.row.level_id"
                      placeholder="等级"
                      clearable
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in levelOptions"
                        :key="item.level_id"
                        :label="item.name"
                        :value="item.level_id"
                      />
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="价格" width="110" align="center">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.price"
                      placeholder="价格"
                      style="width: 100%"
                    />
                  </template>
                </el-table-column>
                <el-table-column label="回收价" width="110" align="center">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.recovery_price"
                      placeholder="回收价"
                      style="width: 100%"
                    />
                  </template>
                </el-table-column>
                <el-table-column label="原始数量" width="110" align="center">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.origin_num"
                      placeholder="原始数量"
                      style="width: 100%"
                    />
                  </template>
                </el-table-column>
                <el-table-column label="概率" width="100" align="center">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.probability"
                      placeholder="概率"
                      style="width: 100%"
                    />
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="100" align="center">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      style="color: #f56c6c"
                      @click="delTempPrize(scope.$index)"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <!-- 已保存数据 -->
            <div>
              <p style="font-weight: bold; margin-bottom: 8px">已保存数据</p>
              <div
                v-loading="prizeLoading"
                style="max-height: 300px; overflow-y: auto"
              >
                <el-table
                  :data="prizeList"
                  border
                  size="mini"
                  style="width: 100%"
                >
                  <el-table-column
                    label="ID"
                    prop="id"
                    width="70"
                    align="center"
                  />
                  <el-table-column
                    label="关卡"
                    prop="box"
                    width="70"
                    align="center"
                  />
                  <el-table-column label="赏品类型" width="110" align="center">
                    <template slot-scope="scope">
                      <span
                        :style="{
                          color:
                            scope.row.goods_type == 1 ? '#008000' : '#1890ff',
                        }"
                      >
                        {{
                          scope.row.goods_type == 1 ? "真实赏品" : "虚拟赏品"
                        }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="等级名称"
                    prop="level_name"
                    width="100"
                    align="center"
                  />
                  <el-table-column label="商品图片" align="center" width="120">
                    <template slot-scope="scope">
                      <img
                        :src="scope.row.goods_image"
                        style="width: 60px; height: 60px; object-fit: cover"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="商品名称"
                    prop="goods_title"
                    min-width="180"
                  />
                  <el-table-column
                    label="单价"
                    prop="price"
                    width="100"
                    align="center"
                  />
                  <el-table-column
                    label="回收价"
                    prop="recovery_price"
                    width="100"
                    align="center"
                  />
                  <el-table-column
                    label="原始数量"
                    prop="origin_num"
                    width="110"
                    align="center"
                  />
                  <el-table-column
                    label="剩余数量"
                    prop="num"
                    width="110"
                    align="center"
                  />
                  <el-table-column
                    label="概率"
                    prop="probability"
                    width="100"
                    align="center"
                  />
                  <el-table-column
                    label="原始概率"
                    prop="origin_probability"
                    width="120"
                    align="center"
                  />
                  <el-table-column
                    label="真实概率"
                    prop="real_probability"
                    width="120"
                    align="center"
                  />
                  <el-table-column
                    label="创建时间"
                    prop="created_at"
                    width="180"
                    align="center"
                  />
                  <el-table-column
                    label="操作"
                    width="180"
                    align="center"
                    fixed="right"
                  >
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        icon="el-icon-edit"
                        @click.stop="openEditPrize(scope.row)"
                      >
                        编辑
                      </el-button>
                      <el-button
                        type="text"
                        icon="el-icon-delete"
                        style="color: #f56c6c"
                        @click.stop="delPrize(scope.row.id)"
                      >
                        删除
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>

                <el-pagination
                  @size-change="handlePrizeSizeChange"
                  @current-change="handlePrizeCurrentChange"
                  :current-page="prizeParams.page"
                  :page-sizes="[10, 20, 50]"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="prizeTotal"
                  style="margin-top: 15px; text-align: right"
                />
              </div>
            </div>
          </el-dialog>
          <!-- 添加赏品 - 选择商品弹窗 -->
          <el-dialog
            title="选择赏品"
            :visible.sync="addPrizeDialogVisible"
            width="1000px"
            append-to-body
          >
            <div
              style="
                display: flex;
                gap: 10px;
                margin-bottom: 15px;
                align-items: center;
              "
            >
              <el-select
                v-model="addPrizeParams.type"
                placeholder="选择等级分类"
                style="width: 180px"
                @change="handleGoodsTypeChange"
                clearable
              >
                <el-option
                  v-for="item in goodsLevelGroup"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>

              <el-select
                v-model="addPrizeParams.level_id"
                placeholder="选择具体等级"
                style="width: 180px"
                clearable
              >
                <el-option
                  v-for="item in currGoodsLevelList"
                  :key="item.level_id"
                  :label="item.name"
                  :value="item.level_id"
                />
              </el-select>

              <el-input
                v-model="addPrizeParams.title"
                placeholder="商品名称"
                style="width: 220px"
                clearable
              />

              <el-button
                type="primary"
                icon="el-icon-search"
                @click="getAddPrizeList"
              >
                搜索
              </el-button>
              <el-button icon="el-icon-refresh" @click="resetAddPrizeSearch">
                重置
              </el-button>
            </div>

            <div
              v-loading="addPrizeLoading"
              style="max-height: 400px; overflow-y: auto"
            >
              <el-table
                ref="addPrizeTableRef"
                :data="addPrizeList"
                border
                stripe
                size="mini"
                @row-click="handleSelectAddPrizeRow"
              >
                <el-table-column type="selection" width="55" align="center" />
                <el-table-column
                  label="ID"
                  prop="id"
                  width="70"
                  align="center"
                />
                <el-table-column label="商品图片" align="center" width="100">
                  <template slot-scope="scope">
                    <img
                      :src="scope.row.image"
                      style="width: 50px; height: 50px; object-fit: cover"
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  label="商品名称"
                  prop="title"
                  min-width="220"
                />
                <el-table-column
                  label="价格"
                  prop="price"
                  width="100"
                  align="center"
                />
                <el-table-column
                  label="类型"
                  prop="type_name"
                  width="100"
                  align="center"
                />
                <el-table-column label="赏品类型" width="110" align="center">
                  <template slot-scope="scope">
                    <span
                      :style="{
                        color:
                          scope.row.goods_type == 1 ? '#008000' : '#1890ff',
                      }"
                    >
                      {{ scope.row.goods_type == 1 ? "真实赏品" : "虚拟赏品" }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="等级"
                  prop="level_name"
                  width="120"
                  align="center"
                />
              </el-table>

              <el-pagination
                @size-change="handleAddPrizeSizeChange"
                @current-change="handleAddPrizeCurrentChange"
                :current-page="addPrizeParams.page"
                :page-sizes="[10, 20, 50]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="addPrizeTotal"
                style="margin-top: 15px; text-align: right"
              />
            </div>

            <div slot="footer">
              <el-button @click="addPrizeDialogVisible = false">取消</el-button>
              <el-button type="primary" @click="confirmAddPrize"
                >确认添加</el-button
              >
            </div>
          </el-dialog>

          <!-- 编辑赏品弹窗 -->
          <el-dialog
            title="编辑赏品"
            :visible.sync="editPrizeDialog"
            width="600px"
            append-to-body
          >
            <el-form
              :model="editPrizeForm"
              label-width="110px"
              style="margin-top: 15px"
            >
              <el-form-item label="赏品ID">
                <span style="color: #666; font-weight: bold">{{
                  editPrizeForm.prize_id
                }}</span>
              </el-form-item>

              <el-form-item label="商品信息">
                <div style="display: flex; align-items: center; gap: 12px">
                  <img
                    :src="editPrizeForm.goods_image"
                    style="
                      width: 70px;
                      height: 70px;
                      object-fit: cover;
                      border-radius: 6px;
                      border: 1px solid #eee;
                    "
                  />
                  <span style="font-size: 14px">{{
                    editPrizeForm.goods_title
                  }}</span>
                </div>
              </el-form-item>

              <el-form-item label="等级">
                <el-select
                  v-model.number="editPrizeForm.level_id"
                  placeholder="请选择等级"
                  style="width: 280px"
                >
                  <el-option
                    v-for="item in levelOptions"
                    :key="item.level_id"
                    :label="item.name"
                    :value="item.level_id"
                  />
                </el-select>
              </el-form-item>

              <el-form-item label="原始数量">
                <el-input
                  v-model="editPrizeForm.origin_num"
                  placeholder="请输入原始数量"
                  style="width: 280px"
                />
              </el-form-item>

              <el-form-item label="概率">
                <el-input
                  v-model="editPrizeForm.probability"
                  placeholder="请输入概率"
                  style="width: 280px"
                />
              </el-form-item>

              <el-form-item label="单价">
                <el-input
                  v-model="editPrizeForm.price"
                  placeholder="请输入单价"
                  style="width: 280px"
                />
              </el-form-item>

              <el-form-item label="回收价">
                <el-input
                  v-model="editPrizeForm.recovery_price"
                  placeholder="请输入回收价"
                  style="width: 280px"
                />
              </el-form-item>
            </el-form>

            <div slot="footer">
              <el-button @click="editPrizeDialog = false">取消</el-button>
              <el-button type="primary" @click="submitEditPrize"
                >确认保存</el-button
              >
            </div>
          </el-dialog>
        </div>
      </div>
    </div>

    <!-- ====================== 移动端（全新重写） ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-goods-container"
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0,0,0,0.4)"
      >
        <!-- 搜索栏 -->
        <div class="mobile-search-group">
          <el-input
            v-model="searchParams.name"
            placeholder="闯关名称"
            clearable
            size="medium"
            prefix-icon="el-icon-search"
          />
          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-button
              type="primary"
              plain
              round
              @click="getList"
              style="flex: 1"
              >搜索</el-button
            >
            <el-button plain round @click="resetSearch" style="flex: 1"
              >重置</el-button
            >
          </div>
        </div>

        <!-- 卡片列表 -->
        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.id"
            @click="openMobileDetail(item)"
          >
            <div class="card-header">
              <img :src="item.image" class="avatar" />
              <div class="info">
                <div class="title">{{ item.name }}</div>
                <div class="meta">
                  ID:{{ item.id }} | 关口{{ item.fight_num }}个 | 售价¥{{
                    item.price
                  }}
                </div>
              </div>
              <div class="status" :class="item.status == 1 ? 'on' : 'off'">
                {{ item.status == 1 ? "上架" : "下架" }}
              </div>
            </div>
            <div class="card-body">
              <div>销量：{{ item.sales }}</div>
              <div>收入：{{ item.income }}</div>
              <div>支出：{{ item.pay }}</div>
              <div>
                利润：
                <span v-if="Number(item.income) === 0">--</span>
                <span
                  v-else
                  :style="{
                    color: item.income - item.pay >= 0 ? '#00c48c' : '#f56c6c',
                  }"
                >
                  {{
                    (((item.income - item.pay) / item.income) * 100).toFixed(2)
                  }}%
                </span>
              </div>
            </div>
            <div class="card-footer">
              <el-button
                size="mini"
                type="primary"
                round
                @click.stop="openMobileEdit(item)"
                >编辑</el-button
              >
              <el-switch
                v-model="item.status"
                size="mini"
                active-text="上架"
                inactive-text="下架"
                :active-value="1"
                :inactive-value="0"
                @click.native.stop
                @change="handleStatusChange(item)"
              />
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="total, prev, pager, next, jumper"
            :total="pageTotal"
            pager-count="2"
            small
          />
        </div>

        <!-- 👇 移动端弹窗：只在移动端显示 -->
        <!-- <div v-if="$isMobile"> -->
        <!-- 移动端详情弹窗 -->
        <el-dialog
          title="闯关详情"
          :visible.sync="mobileDetailVisible"
          width="95%"
          top="8vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <div v-if="mobileDetailRow" style="padding: 10px 0">
            <div style="text-align: center; margin-bottom: 15px">
              <img
                :src="mobileDetailRow.image"
                style="
                  width: 120px;
                  height: 120px;
                  object-fit: cover;
                  border-radius: 8px;
                "
              />
            </div>
            <el-descriptions :column="1" border size="small">
              <el-descriptions-item label="闯关ID">{{
                mobileDetailRow.id
              }}</el-descriptions-item>
              <el-descriptions-item label="名称">{{
                mobileDetailRow.name
              }}</el-descriptions-item>
              <el-descriptions-item label="价格"
                >¥{{ mobileDetailRow.price }}</el-descriptions-item
              >
              <el-descriptions-item label="关口数">{{
                mobileDetailRow.fight_num
              }}</el-descriptions-item>
              <el-descriptions-item label="销量">{{
                mobileDetailRow.sales
              }}</el-descriptions-item>
              <el-descriptions-item label="收入">{{
                mobileDetailRow.income
              }}</el-descriptions-item>
              <el-descriptions-item label="支出">{{
                mobileDetailRow.pay
              }}</el-descriptions-item>
              <el-descriptions-item label="利润">
                <span v-if="Number(mobileDetailRow.income) === 0">--</span>
                <span
                  v-else
                  :style="{
                    color:
                      mobileDetailRow.income - mobileDetailRow.pay >= 0
                        ? '#00C48C'
                        : '#F56C6C',
                  }"
                >
                  {{
                    (
                      ((mobileDetailRow.income - mobileDetailRow.pay) /
                        mobileDetailRow.income) *
                      100
                    ).toFixed(2)
                  }}%
                </span>
              </el-descriptions-item>
              <el-descriptions-item label="状态">
                <span
                  :style="
                    mobileDetailRow.status == 1
                      ? 'color:#00C48C'
                      : 'color:#F56C6C'
                  "
                >
                  {{ mobileDetailRow.status == 1 ? "上架" : "下架" }}
                </span>
              </el-descriptions-item>
            </el-descriptions>
          </div>
          <div slot="footer" style="text-align: right">
            <el-button @click="mobileDetailVisible = false">关闭</el-button>
          </div>
        </el-dialog>

        <!-- 移动端编辑弹窗 -->
        <el-dialog
          title="编辑闯关"
          :visible.sync="mobileEditVisible"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <el-form
            :model="mobileEditForm"
            :rules="addRules"
            ref="mobileEditRef"
            label-width="90px"
            size="small"
          >
            <el-form-item label="闯关名称" prop="name">
              <el-input
                v-model="mobileEditForm.name"
                placeholder="名称"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="闯关图片">
              <div style="display: flex; align-items: center; gap: 10px">
                <el-button
                  type="primary"
                  size="mini"
                  @click="openMobileImageDialog"
                  >选择图片</el-button
                >
                <div
                  v-if="mobileEditForm.image"
                  style="
                    border: 1px solid #eee;
                    padding: 2px;
                    border-radius: 4px;
                  "
                >
                  <img
                    :src="mobileEditForm.image"
                    style="width: 46px; height: 46px; object-fit: cover"
                  />
                </div>
              </div>
            </el-form-item>
            <el-form-item label="价格" prop="price">
              <el-input
                v-model="mobileEditForm.price"
                placeholder="价格"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="关口数" prop="fight_num">
              <el-input
                v-model="mobileEditForm.fight_num"
                placeholder="关口数"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <el-input
                v-model="mobileEditForm.sort"
                placeholder="排序"
                size="medium"
              />
            </el-form-item>
          </el-form>

          <div
            slot="footer"
            style="
              text-align: right;
              display: flex;
              justify-content: flex-end;
              gap: 10px;
            "
          >
            <el-button size="medium" @click="mobileEditVisible = false"
              >取消</el-button
            >
            <el-button type="primary" size="medium" @click="submitMobileEdit"
              >保存</el-button
            >
          </div>
        </el-dialog>

        <!-- 移动端独立图片选择弹窗 -->
        <el-dialog
          title="选择图片"
          :visible.sync="mobileImageDialog"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <div
            v-loading="imageLoading"
            element-loading-text="加载中..."
            style="padding: 5px"
          >
            <div style="display: flex; gap: 8px; margin-bottom: 10px">
              <el-select
                v-model.number="imageSearch.type"
                placeholder="类型"
                size="mini"
                clearable
                style="flex: 1"
              >
                <el-option
                  v-for="item in image_type"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
              <el-button size="mini" type="primary" @click="getImageList"
                >筛选</el-button
              >
              <el-button size="mini" @click="resetImageSearch">重置</el-button>
            </div>

            <div
              style="
                display: flex;
                flex-wrap: wrap;
                gap: 8px;
                max-height: 45vh;
                overflow-y: auto;
                padding: 5px;
              "
            >
              <div
                v-for="img in imageList"
                :key="img.id"
                @click="selectImage(img)"
                style="
                  padding: 3px;
                  border-radius: 6px;
                  cursor: pointer;
                  text-align: center;
                "
                :style="{
                  border:
                    selectedImageUrl == img.url
                      ? '2px solid #1989fa'
                      : '2px solid transparent',
                  background:
                    selectedImageUrl == img.url ? '#f0f7ff' : 'transparent',
                }"
              >
                <img
                  :src="img.url"
                  style="
                    width: 70px;
                    height: 70px;
                    object-fit: cover;
                    border-radius: 4px;
                    display: block;
                  "
                />
                <span
                  style="
                    font-size: 12px;
                    color: #666;
                    margin-top: 3px;
                    display: block;
                  "
                >
                  {{ getImageTypeName(img.type) }}
                </span>
              </div>
            </div>

            <div style="margin-top: 10px; text-align: center">
              <el-pagination
                @size-change="handleImageSizeChange"
                @current-change="handleImageCurrentChange"
                :current-page="imageSearch.page"
                :page-size="imageSearch.page_size"
                layout="prev, pager, next"
                :total="imageTotal"
                pager-count="2"
                small
              />
            </div>
          </div>
          <div slot="footer" style="text-align: right">
            <el-button size="mini" @click="mobileImageDialog = false"
              >取消</el-button
            >
            <el-button
              size="mini"
              type="primary"
              @click="confirmMobileSelectImage"
              >确认</el-button
            >
          </div>
        </el-dialog>
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";
export default {
  name: "FightBoxTable",
  data() {
    return {
      // 移动端新增
      mobileDetailVisible: false,
      mobileDetailRow: null,
      mobileEditVisible: false,
      mobileEditForm: {
        box_id: "",
        name: "",
        image: "",
        price: "",
        fight_num: "",
        sort: "",
      },
      // 移动端独立图片弹窗
      mobileImageDialog: false,

      prizeDialogVisible: false,
      prizeLoading: false,
      prizeList: [],
      prizeTotal: 0,
      prizeParams: {
        page: 1,
        page_size: 10,
        box_id: "",
        box: "",
      },
      boxNumDetailVisible: false,
      boxNumDetail: null,
      fightBoxNumId: "",
      loading: false,
      tableData: [],
      pageTotal: 0,
      searchParams: { page: 1, page_size: 10, name: "" },
      columnOptions: [
        { label: "ID", prop: "id" },
        { label: "名称", prop: "name" },
        { label: "图片", prop: "image" },
        { label: "价格", prop: "price" },
        { label: "销量", prop: "sales" },
        { label: "关口数", prop: "fight_num" },
        { label: "收入", prop: "income" },
        { label: "支出", prop: "pay" },
        { label: "利润", prop: "profit" },
        { label: "排序", prop: "sort" },
        { label: "状态", prop: "status" },
        { label: "创建时间", prop: "created_at" },
        { label: "更新时间", prop: "updated_at" },
        { label: "操作", prop: "action" },
      ],
      checkedColumns: [
        "id",
        "name",
        "image",
        "price",
        "sales",
        "fight_num",
        "income",
        "pay",
        "profit",
        "sort",
        "status",
        "created_at",
        "updated_at",
        "action",
      ],
      dialogVisible: false,
      dialogType: "add",
      form: {
        box_id: "",
        name: "",
        image: "",
        sort: "",
        fight_num: "",
        price: "",
      },
      addRules: {
        name: [{ required: true, message: "请输入闯关名称", trigger: "blur" }],
        image: [{ required: true, message: "请选择图片", trigger: "change" }],
        price: [{ required: true, message: "请输入价格", trigger: "blur" }],
        fight_num: [
          { required: true, message: "请输入关口数", trigger: "blur" },
        ],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
      },
      imageDialogVisible: false,
      imageLoading: false,
      imageList: [],
      imageTotal: 0,
      image_type: [],
      imageSearch: { page: 1, page_size: 10, type: "" },
      selectedImageUrl: "",
      detailDialogVisible: false,
      detailRow: null,
      detailLoading: false,
      showFightBoxCard: false,
      numLoading: false,
      numList: [],
      numTotal: 0,
      numSearch: { page: 1, page_size: 10, box_id: "" },
      typeList: [],
      levelList: [],
      fightBoxNumDialog: false,
      fightBoxNumForm: {
        box: "",
        cycle_num: "",
        type: "",
        goods_id: "",
        price: "",
        loss_price: 0, // 新增亏损预估值
        probability_info: [],
      },
      selectedGoodsName: "",
      goodsDialogVisible: false,
      goodsLoading: false,
      goodsList: [],
      goodsTotal: 0,
      goodsParams: {
        page: 1,
        page_size: 10,
        type: "",
        level_id: "",
        title: "",
        flag: 4,
      },
      selectedGoodsId: null,
      // 关卡抽奖记录
      boxNumDrawRecordDialog: false,
      boxNumDrawLoading: false,
      boxNumDrawList: [],
      boxNumDrawTotal: 0,
      currentBoxDrawInfo: {},
      boxNumDrawParams: {
        page: 1,
        page_size: 10,
        type: 4,
        box_id: "",
        box: "",
      },
      // 添加赏品
      addPrizeDialogVisible: false,
      addPrizeLoading: false,
      addPrizeList: [],
      addPrizeTotal: 0,
      addPrizeParams: {
        page: 1,
        page_size: 10,
        type: "",
        level_id: "",
        title: "",
        flag: 4,
      },
      goodsLevelGroup: [], // 等级分组：闯关/公共
      currGoodsLevelList: [], // 当前选中分组下的等级列表
      tempPrizeList: [], // 未保存数据
      levelOptions: [], // 等级下拉选项
      currentBoxInfo: {}, // 当前关卡信息

      editPrizeDialog: false,
      editPrizeForm: {
        prize_id: "",
        origin_num: "",
        probability: "",
        goods_id: "",
        level_id: "",
        price: "",
        recovery_price: "",
        goods_type: "",
        goods_image: "",
        goods_title: "",
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // ====================== 移动端详情 ======================
    openMobileDetail(row) {
      this.mobileDetailRow = JSON.parse(JSON.stringify(row));
      this.mobileDetailVisible = true;
    },

    // ====================== 移动端编辑 ======================
    openMobileEdit(row) {
      this.mobileEditForm = {
        box_id: row.id,
        name: row.name,
        image: row.image,
        price: row.price + "",
        fight_num: row.fight_num + "",
        sort: row.sort + "",
      };
      this.mobileEditVisible = true;
    },

    async submitMobileEdit() {
      if (!this.mobileEditForm.name || !this.mobileEditForm.price) {
        this.$message.warning("请完善必填项");
        return;
      }
      this.loading = true;
      try {
        const res = await api.fightBox.edit(this.mobileEditForm);
        if (res.data.code == 1000) {
          this.mobileEditVisible = false;
          this.getList();
        }
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },

    // 移动端独立打开图片
    openMobileImageDialog() {
      this.mobileImageDialog = true;
      this.selectedImageUrl = "";
      this.getImageList();
    },
    // 移动端确认图片
    confirmMobileSelectImage() {
      if (!this.selectedImageUrl) return this.$message.warning("请选图");
      this.mobileEditForm.image = this.selectedImageUrl;
      this.mobileImageDialog = false;
    },

    getList() {
      this.loading = true;
      api.fightBox.index({ params: this.searchParams }).then((res) => {
        if (res.data.code == 1000) {
          this.tableData = res.data.data.data;
          this.pageTotal = res.data.data.total;
        }
        this.loading = false;
      });
    },
    // 打开编辑赏品
    openEditPrize(row) {
      this.editPrizeForm = {
        prize_id: row.id,
        origin_num: row.origin_num,
        probability: row.probability,
        goods_id: row.goods_id,
        level_id: row.level_id,
        price: row.price,
        recovery_price: row.recovery_price,
        goods_type: row.goods_type || 1,
        // 图片 + 名称 回显
        goods_image: row.goods_image,
        goods_title: row.goods_title,
      };
      this.editPrizeDialog = true;
    },

    // 提交编辑赏品（接口参数完全按你要求）
    async submitEditPrize() {
      let params = {
        prize_id: this.editPrizeForm.prize_id,
        origin_num: this.editPrizeForm.origin_num,
        probability: this.editPrizeForm.probability,
        goods_id: this.editPrizeForm.goods_id,
        level_id: this.editPrizeForm.level_id,
        price: this.editPrizeForm.price,
        recovery_price: this.editPrizeForm.recovery_price,
        goods_type: this.editPrizeForm.goods_type,
      };
      try {
        const res = await api.fightBox.editFightBoxPrize(params);
        if (res.data.code == 1000) {
          this.editPrizeDialog = false;
          this.getPrizeList(); // 刷新列表
        } else {
        }
      } catch (e) {
        this.$message.error("请求失败");
      }
    },

    // 删除赏品（参数 prize_id）
    async delPrize(prize_id) {
      this.$confirm("确定删除该赏品？", "提示", {
        type: "warning",
      })
        .then(async () => {
          try {
            const res = await api.fightBox.delFightBoxPrize({ prize_id });
            if (res.data.code == 1000) {
              this.getPrizeList();
            } else {
            }
          } catch (e) {}
        })
        .catch(() => {
          this.$message.info("已取消");
        });
    },
    // 打开单关口抽奖记录
    async openBoxNumDrawRecord(row) {
      this.boxNumDrawParams.box_id = this.numSearch.box_id;
      this.boxNumDrawParams.box = row.box;
      this.boxNumDrawParams.page = 1;
      this.currentBoxDrawInfo = { ...row };
      this.boxNumDrawRecordDialog = true;
      await this.getBoxNumDrawRecord();
    },
    // 请求关口抽奖记录列表
    async getBoxNumDrawRecord() {
      this.boxNumDrawLoading = true;
      try {
        const res = await api.blindCate.boxDrawRecord({
          params: this.boxNumDrawParams,
        });
        if (res.data.code == 1000) {
          this.boxNumDrawList = res.data.data.data || [];
          this.boxNumDrawTotal = res.data.data.total || 0;
        }
      } catch (err) {
        this.$message.error("获取抽奖记录失败");
      } finally {
        this.boxNumDrawLoading = false;
      }
    },
    // 每页条数切换
    handleBoxNumDrawSizeChange(val) {
      this.boxNumDrawParams.page_size = val;
      this.getBoxNumDrawRecord();
    },
    // 页码切换
    handleBoxNumDrawCurrentChange(val) {
      this.boxNumDrawParams.page = val;
      this.getBoxNumDrawRecord();
    },
    // 打开添加赏品弹窗
    openAddPrizeDialog() {
      this.addPrizeParams = {
        page: 1,
        page_size: 10,
        type: "",
        level_id: "",
        title: "",
        flag: 4,
      };
      this.currGoodsLevelList = [];
      this.addPrizeDialogVisible = true;
      this.getAddPrizeList().then(() => {
        // 打开赏品库时，自动勾选未保存数据里的商品
        this.$nextTick(() => {
          if (!this.$refs.addPrizeTableRef) return;
          // 清空原有选择
          this.$refs.addPrizeTableRef.clearSelection();
          // 未保存商品ID集合
          const tempIds = this.tempPrizeList.map((item) => item.id);
          // 自动勾选
          this.addPrizeList.forEach((row) => {
            if (tempIds.includes(row.id)) {
              this.$refs.addPrizeTableRef.toggleRowSelection(row, true);
            }
          });
        });
      });
    },

    // 获取可选择的赏品列表
    async getAddPrizeList() {
      this.addPrizeLoading = true;
      try {
        const res = await api.goods.index({ params: this.addPrizeParams });
        if (res.data.code == 1000) {
          this.addPrizeList = res.data.data.data || [];
          this.addPrizeTotal = res.data.data.total || 0;
          this.goodsLevelGroup = res.data.data.goods_level || [];
          this.currGoodsLevelList = [];
        }
      } catch (e) {
        this.$message.error("获取商品失败");
      } finally {
        this.addPrizeLoading = false;
      }
    },

    // 等级分组切换 → 二级联动
    handleGoodsTypeChange(val) {
      this.addPrizeParams.level_id = "";
      let group = this.goodsLevelGroup.find((item) => item.type == val);
      this.currGoodsLevelList = group ? group.goods_level : [];
    },

    // 点击行 = 选中
    handleSelectAddPrizeRow(row) {
      this.$refs.addPrizeTableRef.toggleRowSelection(row);
    },

    // 选择商品后 → 添加到未保存列表
    confirmAddPrize() {
      let selected = this.$refs.addPrizeTableRef.selection;
      if (!selected || selected.length === 0) {
        return this.$message.warning("请选择商品");
      }

      // 已存在的商品 ID 集合（只针对 goods_type == 1 去重）
      const existRealIds = this.tempPrizeList
        .filter((item) => item.goods_type == 1)
        .map((item) => item.id);

      // 过滤：真实赏品去重，虚拟赏品保留
      let newItems = selected.filter((item) => {
        if (item.goods_type == 1) {
          return !existRealIds.includes(item.id);
        }
        return true;
      });

      if (newItems.length === 0) {
        return this.$message.warning("所选真实赏品已存在，无需重复添加");
      }

      // 👇 改动在这里：自动带入价格、回收价
      let arr = newItems.map((item) => ({
        id: item.id,
        image: item.image,
        title: item.title,
        goods_type: item.goods_type || 1,
        level_id: item.level_id || "",
        price: item.price || 0, // 自动带商品价格
        recovery_price: item.price || 0, // 自动带回收价
        origin_num: 0,
        probability: 0,
      }));

      this.tempPrizeList = [...this.tempPrizeList, ...arr];
      this.addPrizeDialogVisible = false;

      this.$nextTick(() => {
        if (this.$refs.addPrizeTableRef) {
          this.$refs.addPrizeTableRef.clearSelection();
        }
      });

      this.$message.success(`已添加 ${newItems.length} 个商品到未保存数据`);
    },
    // 删除未保存数据
    delTempPrize(index) {
      this.tempPrizeList.splice(index, 1);
    },
    // 分页
    handleAddPrizeSizeChange(val) {
      this.addPrizeParams.page_size = val;
      this.getAddPrizeList();
    },
    handleAddPrizeCurrentChange(val) {
      this.addPrizeParams.page = val;
      this.getAddPrizeList();
    },

    // 重置筛选
    resetAddPrizeSearch() {
      this.addPrizeParams = {
        page: 1,
        page_size: 10,
        type: "",
        level_id: "",
        title: "",
        flag: 4,
      };
      this.currGoodsLevelList = [];
      this.getAddPrizeList();
    },
    // 打开赏品列表
    async openPrizeList(row) {
      // 上一次的关卡 ID
      const oldBoxId = this.prizeParams.box_id;
      // 本次要打开的关卡 ID
      const newBoxId = row.box_id;
      // ==============================================
      // 核心：只要 不是同一个ID → 强制清空未保存数据
      // ==============================================
      if (this.prizeParams.box != row.box) {
        this.tempPrizeList = [];
      }

      // 赋值新数据
      this.prizeParams.box_id = newBoxId;
      this.prizeParams.box = row.box;
      this.currentBoxInfo = { ...row };
      this.prizeParams.page = 1;

      this.prizeDialogVisible = true;
      await this.getPrizeList();
    },
    async submitAddPrize() {
      if (this.tempPrizeList.length == 0) {
        return this.$message.warning("请先选择赏品");
      }

      // 1. 获取周期数量
      let cycle_num = Number(this.currentBoxInfo.cycle_num) || 0;
      if (!cycle_num) {
        return this.$message.error("未获取到当前关卡的周期数量");
      }

      // ===============
      // 已保存统计（只取 probability）
      // ===============
      let saved_origin_num_total = 0;
      let saved_prob_total = 0;

      this.prizeList.forEach((item) => {
        saved_origin_num_total += Number(item.origin_num || 0);
        saved_prob_total += parseFloat(item.probability || 0); // 已保存概率总和
      });

      // ===============
      // 未保存统计（只取 probability）
      // ===============
      let temp_origin_num_total = 0;
      let temp_prob_total = 0;

      this.tempPrizeList.forEach((item) => {
        temp_origin_num_total += Number(item.origin_num || 0);
        temp_prob_total += parseFloat(item.probability || 0); // 未保存概率总和
      });

      // ===============
      // ✅ 概率总和校验（已保存 + 未保存 ≤ 100）
      // ===============
      let total_prob = saved_prob_total + temp_prob_total;
      if (total_prob > 100) {
        return this.$message.error(
          `❌ 概率总和不能大于 100%\n\n` +
            `已保存概率：${saved_prob_total.toFixed(2)}%\n` +
            `未保存概率：${temp_prob_total.toFixed(2)}%\n` +
            `总概率：${total_prob.toFixed(2)}%`
        );
      }

      // ===============
      // ✅ 数量校验
      // ===============
      let total_num = saved_origin_num_total + temp_origin_num_total;
      if (total_num > cycle_num) {
        return this.$message.error(
          `❌ 数量超出限制\n\n` +
            `已保存原始数量：${saved_origin_num_total}\n` +
            `未保存原始数量：${temp_origin_num_total}\n` +
            `总数量：${total_num}\n` +
            `最大允许：${cycle_num}`
        );
      }

      // 提交接口
      let prize_info = this.tempPrizeList.map((item) => ({
        goods_id: item.id,
        level_id: item.level_id,
        price: item.price || 0,
        recovery_price: item.recovery_price || 0,
        origin_num: item.origin_num || 0,
        probability: item.probability || 0,
        goods_type: item.goods_type || 1,
      }));

      let params = {
        box_id: this.currentBoxInfo.box_id,
        box: this.currentBoxInfo.box,
        prize_info: JSON.stringify(prize_info),
      };

      try {
        const res = await api.fightBox.addFightBoxPrize(params);
        if (res.data.code == 1000) {
          this.tempPrizeList = [];
          this.getPrizeList();
        } else {
        }
      } catch (e) {
        this.$message.error("接口请求失败");
      }
    },
    // 获取赏品列表
    async getPrizeList() {
      this.prizeLoading = true;
      try {
        const res = await api.fightBox.fightBoxPrizeList({
          params: this.prizeParams,
        });
        if (res.data.code == 1000) {
          this.prizeList = res.data.data.data || [];
          this.prizeTotal = res.data.data.total || 0;

          // 加载等级选项
          let levelData = res.data.data.level || [];
          this.levelOptions = levelData.map((item) => ({
            level_id: item.level_id,
            name: item.name,
          }));
        }
      } catch (e) {
        this.$message.error("获取赏品失败");
      } finally {
        this.prizeLoading = false;
      }
    },

    // 赏品分页
    handlePrizeSizeChange(val) {
      this.prizeParams.page_size = val;
      this.getPrizeList();
    },
    handlePrizeCurrentChange(val) {
      this.prizeParams.page = val;
      this.getPrizeList();
    },
    async handleStatusChange(row) {
      try {
        this.loading = true;
        await api.fightBox.status({ box_id: row.id, status: row.status });
        this.getList();
      } catch (e) {
        row.status = row.status == 1 ? 0 : 1;
      } finally {
        this.loading = false;
      }
    },
    handleRowClick(row) {
      this.detailRow = row;
      this.detailDialogVisible = true;
    },
    handleAdd() {
      this.dialogType = "add";
      this.resetForm();
      this.dialogVisible = true;
    },
    handleEdit(row) {
      this.dialogType = "edit";
      this.form = {
        box_id: row.id,
        name: row.name,
        image: row.image,
        price: row.price + "",
        fight_num: row.fight_num + "",
        sort: row.sort + "",
      };
      this.dialogVisible = true;
    },
    // 显示关卡详情（含概率）
    showBoxNumDetail(row) {
      this.boxNumDetail = row;
      this.boxNumDetailVisible = true;
    },
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        const fn =
          this.dialogType == "add" ? api.fightBox.add : api.fightBox.edit;
        fn(this.form).then((res) => {
          if (res.data.code == 1000) {
            this.dialogVisible = false;
            this.getList();
          }
          this.loading = false;
        });
      });
    },
    resetSearch() {
      this.searchParams = { page: 1, page_size: 10, name: "" };
      this.getList();
    },
    resetForm() {
      this.form = {
        box_id: "",
        name: "",
        image: "",
        sort: "",
        fight_num: "",
        price: "",
      };
      this.$nextTick(
        () => this.$refs.formRef && this.$refs.formRef.clearValidate()
      );
    },
    openImageDialog() {
      this.imageDialogVisible = true;
      this.selectedImageUrl = "";
      this.getImageList();
    },
    getImageList() {
      this.imageLoading = true;
      api.images.index({ params: this.imageSearch }).then((res) => {
        if (res.data.code == 1000) {
          this.imageList = res.data.data.data || [];
          this.imageTotal = res.data.data.total;
          this.image_type = res.data.data.image_type || [];
        }
        this.imageLoading = false;
      });
    },
    selectImage(img) {
      this.selectedImageUrl = img.url;
    },
    confirmSelectImage() {
      if (!this.selectedImageUrl) return this.$message.warning("请选图");
      this.form.image = this.selectedImageUrl;
      this.imageDialogVisible = false;
    },
    resetImageSearch() {
      this.imageSearch = { page: 1, page_size: 10, type: "" };
      this.getImageList();
    },
    handleImageSizeChange(val) {
      this.imageSearch.page_size = val;
      this.getImageList();
    },
    // 删除关卡
    async delFightBoxNum(box_num_id) {
      this.$confirm("此操作将永久删除该关卡, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            // 接口：只传 box_num_id
            await api.fightBox.delFightBoxNum({ box_num_id });
            this.getFightBoxNumList(); // 刷新列表
          } catch (e) {}
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    handleImageCurrentChange(val) {
      this.imageSearch.page = val;
      this.getImageList();
    },
    getImageTypeName(type) {
      const t = this.image_type.find((i) => i.type == type);
      return t ? t.desc : "未知";
    },
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getList();
    },
    handleCheckAll() {
      this.checkedColumns = this.columnOptions.map((i) => i.prop);
    },
    handleClearAll() {
      this.checkedColumns = [];
    },
    async openFightBoxNum(row) {
      this.numSearch.box_id = row.id;
      this.numSearch.page = 1;
      this.showFightBoxCard = true;
      this.numLoading = true;
      const res = await api.fightBox.getFightBoxNumList({
        params: this.numSearch,
      });
      if (res.data.code == 1000) {
        this.numList = res.data.data.data || [];
        this.numTotal = res.data.data.total || 0;
        this.typeList = res.data.data.type || [];
        this.levelList = res.data.data.level || [];
      }
      this.numLoading = false;
    },
    closeFightBoxCard() {
      this.showFightBoxCard = false;
    },
    handleNumSizeChange(val) {
      this.numSearch.page_size = val;
      this.getFightBoxNumList();
    },
    handleNumCurrentChange(val) {
      this.numSearch.page = val;
      this.getFightBoxNumList();
    },
    async getFightBoxNumList() {
      this.numLoading = true;
      const res = await api.fightBox.getFightBoxNumList({
        params: this.numSearch,
      });
      if (res.data.code == 1000) {
        this.numList = res.data.data.data || [];
        this.numTotal = res.data.data.total || 0;
      }
      this.numLoading = false;
    },
    handleFightBoxAdd() {
      this.fightBoxNumId = "";
      this.resetFightBoxNumForm();
      if (this.levelList.length > 0) {
        let arr = [];
        for (let i = 0; i < this.levelList.length; i++) {
          arr.push({ level_id: this.levelList[i].level_id, probability: 0 });
        }
        this.fightBoxNumForm.probability_info = arr;
      }
      this.fightBoxNumDialog = true;
    },
    resetFightBoxNumForm() {
      this.fightBoxNumForm = {
        box: "",
        cycle_num: "",
        type: "",
        goods_id: "",
        price: "",
        loss_price: 0, // 重置清空
        probability_info: [],
      };
      this.selectedGoodsName = "";
      this.selectedGoodsId = null;
    },
    async handleFightBoxEdit(row) {
      this.fightBoxNumId = row.id;
      this.resetFightBoxNumForm();
      this.fightBoxNumForm.box = row.box;
      this.fightBoxNumForm.cycle_num = row.cycle_num;
      this.fightBoxNumForm.type = row.type;
      this.fightBoxNumForm.goods_id = row.goods_id;
      this.fightBoxNumForm.price = row.price;
      this.fightBoxNumForm.loss_price = row.loss_price || 0;
      this.selectedGoodsId = row.goods_id;
      this.selectedGoodsName = row.goods_name || "";
      let probabilityArr = row.probability || [];
      let finalProb = [];
      this.levelList.forEach((level) => {
        let find = probabilityArr.find(
          (item) => item.level_id == level.level_id
        );
        finalProb.push({
          level_id: level.level_id,
          probability: find ? parseFloat(find.probability) : 0,
        });
      });
      this.fightBoxNumForm.probability_info = finalProb;
      this.fightBoxNumDialog = true;
    },

    // ✅✅✅ 唯一正确提交方法，严格按你要求
    async submitAdd() {
      if (!this.fightBoxNumForm.box) return this.$message.warning("请输入关口");
      if (!this.fightBoxNumForm.type)
        return this.$message.warning("请选择类型");
      if (this.fightBoxNumForm.type == 1 && !this.fightBoxNumForm.price)
        return this.$message.warning("请输入单价");
      if (this.fightBoxNumForm.type == 2 && !this.fightBoxNumForm.goods_id)
        return this.$message.warning("请选择商品");

      this.numLoading = true;
      try {
        const boxId = this.numSearch.box_id;

        if (this.fightBoxNumId) {
          // ===============================
          // 只改这里！编辑传参：严格按你要求
          // ===============================
          const params = {
            box_num_id: this.fightBoxNumId,
            probability_info: JSON.stringify(
              this.fightBoxNumForm.probability_info
            ),
            price: this.fightBoxNumForm.price,
            loss_price: this.fightBoxNumForm.loss_price, // 新增
            goods_id: this.fightBoxNumForm.goods_id,
            type: this.fightBoxNumForm.type,
            cycle_num: this.fightBoxNumForm.cycle_num,
          };
          await api.fightBox.editFightBoxNum(params);
        } else {
          // 添加：不动
          const params = {
            box_id: boxId,
            box_num_info: JSON.stringify([this.fightBoxNumForm]),
          };
          await api.fightBox.addFightBoxNum(params);
        }

        this.fightBoxNumDialog = false;
        this.getFightBoxNumList();
      } catch (e) {
      } finally {
        this.numLoading = false;
      }
    },

    openGoodsDialog() {
      this.goodsDialogVisible = true;
      this.selectedGoodsId = null;
      this.getGoodsList();
    },
    async getGoodsList() {
      this.goodsLoading = true;
      try {
        const res = await api.goods.index({ params: this.goodsParams });
        if (res.data.code == "1000" || res.data.code == 1000) {
          this.goodsList = res.data.data.data || [];
          this.goodsTotal = res.data.data.total || 0;
        }
      } catch (e) {
        this.$message.error("商品加载失败");
      } finally {
        this.goodsLoading = false;
      }
    },
    handleGoodsSizeChange(val) {
      this.goodsParams.page_size = val;
      this.getGoodsList();
    },
    handleGoodsCurrentChange(val) {
      this.goodsParams.page = val;
      this.getGoodsList();
    },
    selectGoodsItem(item) {
      this.selectedGoodsId = item.id;
    },
    confirmSelectGoods() {
      if (!this.selectedGoodsId) {
        this.$message.warning("请选择商品");
        return;
      }
      const sel = this.goodsList.find(
        (item) => item.id == this.selectedGoodsId
      );
      if (sel) {
        this.fightBoxNumForm.goods_id = sel.id;
        this.selectedGoodsName = sel.title;
      }
      this.goodsDialogVisible = false;
    },
  },
};
</script>

<style scoped>
/* ====================== PC 原有样式（完全不动） ====================== */
.menu-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.goods-list {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}
.goods-item {
  width: 120px;
  text-align: center;
  border: 1px solid #eee;
  padding: 10px;
  border-radius: 6px;
  cursor: pointer;
}
.goods-selected {
  border-color: #409eff;
  background: #f0f7ff;
}

/* ====================== 移动端全新样式 ====================== */
.mobile-goods-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
.avatar {
  width: 50px;
  height: 50px;
  border-radius: 6px;
  object-fit: cover;
}
.info {
  flex: 1;
}
.title {
  font-size: 16px;
  font-weight: 500;
}
.meta {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.status {
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
}
.status.on {
  background: #e6f7ee;
  color: #00c48c;
}
.status.off {
  background: #fef0f0;
  color: #f56c6c;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 10px;
}
.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/fight/index.vue